// extracted by mini-css-extract-plugin
export default {"lg-btn":"LgButton_lg-btn__0jNeX"};